// extracted by mini-css-extract-plugin
module.exports = {"content":"Faq_content__Y9kSR","faq":"Faq_faq__Kqmay"};